import { render, staticRenderFns } from "./DeanAdd.vue?vue&type=template&id=630fbdf2&scoped=true&"
import script from "./DeanAdd.vue?vue&type=script&lang=js&"
export * from "./DeanAdd.vue?vue&type=script&lang=js&"
import style0 from "./DeanAdd.vue?vue&type=style&index=0&id=630fbdf2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630fbdf2",
  null
  
)

export default component.exports